import { css, CSSResult } from 'lit'
import { csColorBorder, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseSteps = {
  columnGap: css`var(--cse-steps-column-gap, ${csSpacing.spacing05})`,
  minWidth: css`var(--cse-steps-min-width, 300px)`,
  rowGap: css`var(--cse-steps-row-gap, ${csSpacing.spacing08})`,
  initialStatusbarBackgroundColor: css`var(--cse-steps-initial-statusbar-background-color, ${csColorBorder.light})`,
  completedStatusbarBackgroundColor: css`var(--cse-steps-completed-statusbar-background-color, ${csColorFunctional.info})`,
}

export const style: CSSResult = css`
  /* CSE Step */
  /* -------------------- */
  .cse-steps {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    min-width: ${cseSteps.minWidth};
    column-gap: ${cseSteps.columnGap};
    row-gap: ${cseSteps.rowGap};
  }

  .cse-steps::before {
    --initial-background-color: ${cseSteps.initialStatusbarBackgroundColor};
    --active-background-color: ${cseSteps.completedStatusbarBackgroundColor};
    --deg: 90deg;
    content: '';
    background: linear-gradient(var(--deg), var(--active-background-color) var(--percentage), var(--initial-background-color) var(--percentage));
    height: 3px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 20px);
    z-index: -1;
  }

  /* Variants */
  /* -------------------- */
  .variant-vertical {
    flex-direction: column;
    width: fit-content;
    min-width: auto;
  }

  .variant-vertical::before {
    --deg: 180deg;
    height: calc(100% - 20px);
    left: 10px;
    transform: translate(-50%, -50%);
    width: 3px;
  }
`
